import { decryptId } from "../../../Components/CryptoComponent";
import AddLookup from "../../../Components/InputComponents/AddLookup";
import { useParams, useSearchParams } from "react-router-dom";

function EditProfession() {
  const { id } = useParams();
  const decryptedId = decryptId(decodeURIComponent(id));

  const [searchParams] = useSearchParams();
  const redirectURL = `/ProfessionLookup?${searchParams.toString()}`;

  return (
    <AddLookup
      title="Edit Profession"
      alert="Profession Edited Successfully"
      editDataAPIEndPoint={`/Profession/Edit/${decryptedId}`}
      viewDataDetailsAPIEndPoint={`/Profession/listbyId/${decryptedId}`}
      redirectURL={redirectURL}
      sections={[
        {
          fields: [
            {
              type: "text",
              label: "Profession",
              name: "PI_Name",
              required: true, // Validation rule added here
               maxLength:70
            },
            {
              type: "select",
              label: "Status",
              name: "PI_Status",
              required: true, // Validation rule added here
                            options: [
                { label: "Active", value:'1'},
                { label: "Inactive", value: '0'},
              ],
            },
          ],
        },
      ]}
      validationRules={{
        PI_Name: {
          required: true,
          
        },
        PI_Status: {
          required: true,
        },
      }}
    />
  );
}

export default EditProfession;
